import { Alert, Button, Container, FormField, Header, KeyValuePairs, SpaceBetween, SplitPanel } from '@cloudscape-design/components';
import { mdiTrophyOutline } from '@mdi/js';
import Icon from '@mdi/react';
import React, { useEffect } from 'react';
import { useGlobalState } from '../../pages/context/GlobalStateContext';
import { ItemsMovement } from '../../resources/types';
import Copy from '../Copy';



interface SidePanelMovementProps {
    movement: Partial<ItemsMovement>;
}

const SidePanelMovementPax: React.FC<SidePanelMovementProps> = ({
    movement,
}) => {
    const { menu, parameters, data } = useGlobalState();


    useEffect(() => {
    }, [movement]);
    return (
        <SplitPanel
            hidePreferencesButton
            header={`Detalle de movimiento`}
            /*headerDescription={<ViewerJson code={movement} theme={parameters?.theme} />}**/
            headerActions={
                movement && (
                    <SpaceBetween direction='horizontal' size='xs'>

                        <Copy value={movement?.idMovement?.toString() ?? ""} />
                    </SpaceBetween>
                )
            }
            closeBehavior="hide"
        >
            {movement && (<>

                <SpaceBetween direction="vertical" size="xs">


                    {/* Usuario */}
                    {movement?.idUser === 6559 && (

                        <Container header={"PAX"}>
                            <SpaceBetween direction="vertical" size="xs">
                                <KeyValuePairs
                                    columns={1}
                                    items={[
                                        { label: "Pasajero", value: movement.jsonMovement.nombre },
                                    ]}
                                />
                                <KeyValuePairs
                                    columns={2}
                                    items={[
                                        { label: "Móvil", value: movement.jsonMovement.movil },
                                        { label: "Email", value: movement.jsonMovement.email },
                                    ]}
                                />

                                <KeyValuePairs
                                    columns={1}
                                    items={[
                                        { label: "Observaciones", value: movement.jsonMovement.obs },
                                    ]}
                                />
                                {movement?.jsonMovement?.dateEndSell !== "" && movement?.voucherStage === 1 && (
                                    <Alert type="info" header="Información">
                                        Venta finaliza el: <b>{movement?.jsonMovement?.dateEndSell}</b>
                                    </Alert>
                                )}


                                {movement?.idUser === 6559 ? (
                                    movement?.jsonMovement?.mercenaries?.length > 0 ? (
                                        <Container header="Mercenarios asociados">
                                            <SpaceBetween direction="vertical" size="xs">
                                                {movement.jsonMovement.mercenaries
                                                    .sort((a: any, b: any) =>
                                                        b.won !== a.won
                                                            ? b.won - a.won
                                                            : a.displayName.localeCompare(b.displayName)
                                                    )
                                                    .map((mercenary: any, index: number) => (
                                                        <FormField
                                                            key={mercenary.idUser ?? index}
                                                            label={
                                                                <>
                                                                    {mercenary.won == 1 && (
                                                                        <Icon path={mdiTrophyOutline} size={1} />
                                                                    )}{" "}
                                                                    {mercenary.displayName}
                                                                </>
                                                            }
                                                        />
                                                    ))}
                                            </SpaceBetween>
                                        </Container>
                                    ) : (
                                        <Alert type="error" header="Postulantes">
                                            Sin postulaciones inscritas</Alert>
                                    )
                                ) : null}
                            </SpaceBetween>
                        </Container>
                    )}
                    {movement?.idUser !== 6559 && (
                        <Container header={<Header variant='h3'>Usuario</Header>}>
                            <KeyValuePairs
                                columns={2}
                                items={[
                                    { label: "Socio", value: movement.displayName },
                                    { label: "RUT", value: movement.RUT },
                                ]}
                            />
                        </Container>
                    )}
                    <Container header={<Header variant='h3'
                        actions={!!movement?.receipt && movement?.receipt !== "0" && (
                            <>Comprobante #{movement.receipt}</>

                        )}
                    >Movimiento</Header>}>
                        <SpaceBetween direction='vertical' size='xs'>
                            <FormField label={movement.data}
                                constraintText={movement.accountPlan}
                            >
                                {movement.obs}

                            </FormField>
                            {movement.ammount === 0 && (
                                <Alert type="info" header={"Información"}>
                                    Este movimiento no tiene cargo o abono asociado
                                </Alert>
                            )}

                        </SpaceBetween>

                    </Container>


                    {/* Detalle TBK */}
                    {movement?.jsonTBK?.amount ? (
                        <Container header={<h3>Detalle TBK</h3>}>
                            <KeyValuePairs
                                columns={4}
                                items={[
                                    {
                                        label: "Tarjeta",
                                        value: `**** **** **** ${movement.jsonTBK.card_detail.card_number}`
                                    },
                                    {
                                        label: "Autorización",
                                        value: movement.jsonTBK.authorization_code
                                    },
                                    {
                                        label: "Tipo venta",
                                        value: movement.jsonTBK.payment_type_code
                                    },
                                    {
                                        label: "Cuotas",
                                        value: movement.jsonTBK.installments_number
                                    }
                                ]}
                            />
                        </Container>
                    ) : null}

                    {/* Combustible */}
                    {movement?.jsonMovement?.counterEnd && movement.jsonMovement.registration ? (
                        <Container header={<h3>{`Combustible ${movement.jsonMovement.registration}`}</h3>}>
                            <KeyValuePairs
                                columns={3}
                                items={[
                                    {
                                        label: "Numerales",
                                        value: `${movement.jsonMovement.counterStart} al ${movement.jsonMovement.counterEnd}`
                                    },
                                    {
                                        label: "Litros",
                                        value: `${movement.jsonMovement.liters} LT`
                                    },
                                    {
                                        label: "Precio",
                                        value: movement.jsonMovement.price
                                    }
                                ]}
                            />
                        </Container>
                    ) : null}

                    {/* Facturación */}
                    {movement?.jsonDocuments?.number ? (
                        <Container header={
                            <Header variant="h3" actions={
                                movement.jsonDocuments.number && movement.jsonDocuments.number > 0 && (
                                    <SpaceBetween direction='horizontal' size='xs'>
                                        {movement.jsonDocuments?.pdf !== "" && (
                                            <Button variant="primary" external href={movement.jsonDocuments?.pdf}>PDF</Button>
                                        )}

                                        {movement.jsonDocuments?.xml !== "" && (
                                            <Button variant="primary" external href={movement.jsonDocuments?.xml}>XML</Button>
                                        )}

                                    </SpaceBetween>
                                )}>Facturación</Header>
                        }>
                            <KeyValuePairs
                                columns={3}
                                items={[
                                    { label: "Factura #", value: movement.jsonDocuments.number },
                                    {
                                        label: "Fecha emisión",
                                        value: movement.jsonDocuments.dte.Encabezado.IdDoc.FchEmis
                                    },
                                    {
                                        label: "Razón Social",
                                        value: movement.jsonDocuments.dte.Encabezado.Receptor.RznSocRecep
                                    },
                                    {
                                        label: "Giro",
                                        value: movement.jsonDocuments.dte.Encabezado.Receptor.GiroRecep
                                    }
                                ]}
                            />
                        </Container>
                    ) : null}


                    {movement?.jsonBank?.sender_account ? (
                        <Container header={<h3>{`Transferencia ${movement.jsonBank.reference_id}`}</h3>}>
                            <KeyValuePairs
                                columns={3}
                                items={[
                                    {
                                        label: "Banco",
                                        value: movement.jsonBank.sender_account.institution.name
                                    },
                                    {
                                        label: "Cuenta",
                                        value: movement.jsonBank.sender_account.number
                                    },
                                    {
                                        label: "RUT",
                                        value: movement.jsonBank.sender_account.holder_id
                                    }
                                ]}
                            />
                        </Container>
                    ) : null}


                </SpaceBetween>
            </>)}
        </SplitPanel>
    );


};

export default SidePanelMovementPax;